import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import { useIntl } from 'react-intl';
import { Route } from 'react-router-dom';

// Components
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Button from '../../components/Button';

// Assets
import cover from './assets/cover.jpg';

// Router
import { getRoute } from '../../entry/routes';

// Styles
import styles from './Error404.styl';

const cx = classNames.bind(styles);

export default function Error404Page() {
  const intl = useIntl();
  const isRealPhone = useSelector(state => state.responsive.isRealPhone);

  return (
    <Route>
      {({ staticContext }) => {
        if (staticContext) {
          staticContext.statusCode = 404;
        }

        return (
          <>
            <Helmet title={intl.formatMessage({ id: 'page.error404.helmetTitle' })} />
            <Container className={cx('Error404')}>
              <div className={cx('Error404__content')}>
                <Heading className={cx('Error404__title')} level={1}>
                  {intl.formatMessage({ id: 'page.error404.title' })}
                </Heading>
                <div className={cx('Error404__subtitle')}>
                  {intl.formatMessage({ id: 'page.error404.subtitle' })}
                </div>
                <Button className={cx('Error404__button')} to={getRoute('home')}>
                  {intl.formatMessage({ id: 'button.goToMenu.long' })}
                </Button>
              </div>
              {!isRealPhone && <img className={cx('Error404__image')} src={cover} alt="error" />}
            </Container>
          </>
        );
      }}
    </Route>
  );
}
